import { render, staticRenderFns } from "./ConfiguracionAlianza.vue?vue&type=template&id=45acc939"
import script from "./ConfiguracionAlianza.vue?vue&type=script&lang=js"
export * from "./ConfiguracionAlianza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45acc939')) {
      api.createRecord('45acc939', component.options)
    } else {
      api.reload('45acc939', component.options)
    }
    module.hot.accept("./ConfiguracionAlianza.vue?vue&type=template&id=45acc939", function () {
      api.rerender('45acc939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/alianzas/ConfiguracionAlianza.vue"
export default component.exports